// GENERATED FILE. Do not edit by hand. Produced by `bun run codegen`.

import Ajv from "ajv";
import addFormats from "ajv-formats";
import call from "../../sdk-helpers/call";
import { logError } from "../../sdk-helpers/shouldLog";

export type typeSquaresGridAddBody = {
  poolId: string;
  eventId?: string | null;
  gameRule?: {
    presetKey:
      | "oneGame"
      | "allGames"
      | "tnf"
      | "snf"
      | "mnf"
      | "thanksgiving"
      | "christmas"
      | "playoffs"
      | "conference"
      | "team"
      | "bowls"
      | "cfp"
      | "ncaaTournament"
      | "conferenceTournaments"
      | "openingDay"
      | "worldSeries"
      | "matchdayRange"
      | "customDates";
    seasonYear?: number | null;
    eventId?: string | null;
    teamId?: string | null;
    conferenceKey?: string | null;
    customDates?: {
      mode: "range" | "dates";
      fromDay?: string;
      toDay?: string;
      days?: string[];
    } | null;
    excludedEventIds: string[];
  } | null;
  doPublishNow: boolean;
  doNotifyMembers: boolean;
  transactionId: string;
};

export type typeSquaresGridAddOutput200 = {
  error?: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data?: null | { status: "created" | "existing"; gridIds: string[] };
};

export type typeSquaresGridAddOutput400 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridAddOutput401 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export type typeSquaresGridAddOutput500 = {
  error: {
    code: string;
    message: string;
    details?: Record<string, unknown>;
  } | null;
  data: null;
};

export const schemaSquaresGridAddBody = {
  type: "object",
  properties: {
    poolId: { type: "string", maxLength: 3000, minLength: 1 },
    eventId: {
      oneOf: [
        { type: "string", maxLength: 3000, minLength: 1 },
        { enum: [null] },
      ],
    },
    gameRule: {
      oneOf: [
        {
          type: "object",
          properties: {
            presetKey: {
              type: "string",
              enum: [
                "oneGame",
                "allGames",
                "tnf",
                "snf",
                "mnf",
                "thanksgiving",
                "christmas",
                "playoffs",
                "conference",
                "team",
                "bowls",
                "cfp",
                "ncaaTournament",
                "conferenceTournaments",
                "openingDay",
                "worldSeries",
                "matchdayRange",
                "customDates",
              ],
            },
            seasonYear: { oneOf: [{ type: "integer" }, { enum: [null] }] },
            eventId: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            teamId: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            conferenceKey: {
              oneOf: [
                { type: "string", maxLength: 3000, minLength: 1 },
                { enum: [null] },
              ],
            },
            customDates: {
              oneOf: [
                {
                  type: "object",
                  properties: {
                    mode: { type: "string", enum: ["range", "dates"] },
                    fromDay: { type: "string", maxLength: 3000, minLength: 1 },
                    toDay: { type: "string", maxLength: 3000, minLength: 1 },
                    days: {
                      type: "array",
                      items: { type: "string", maxLength: 3000, minLength: 1 },
                    },
                  },
                  required: ["mode"],
                },
                { enum: [null] },
              ],
            },
            excludedEventIds: {
              type: "array",
              items: { type: "string", maxLength: 3000, minLength: 1 },
            },
          },
          required: ["presetKey", "excludedEventIds"],
        },
        { enum: [null] },
      ],
    },
    doPublishNow: { type: "boolean" },
    doNotifyMembers: { type: "boolean" },
    transactionId: { type: "string", maxLength: 3000, minLength: 1 },
  },
  required: ["poolId", "doPublishNow", "doNotifyMembers", "transactionId"],
} as const;

export type SdkOptions = {
  headers?: Record<string, string>;
  apiHost?: string;
  prefix?: string;
};

let compiledValidator: ReturnType<Ajv["compile"]> | null = null;

export default function createSquaresGridAdd(options: SdkOptions) {
  if (!compiledValidator) {
    const ajv = new Ajv({ strict: false });
    addFormats(ajv);
    compiledValidator = ajv.compile(schemaSquaresGridAddBody);
  }

  return async function postSquaresGridAdd(
    payload: typeSquaresGridAddBody,
  ): Promise<typeSquaresGridAddOutput200 | typeSquaresGridAddOutput400> {
    const isValid = compiledValidator!(payload);
    if (!isValid) {
      logError(
        `Payload validation inside SDK method "postSquaresGridAdd" failed before calling the network. #4f628713c341`,
        compiledValidator!.errors,
      );
      return {
        error: {
          code: "VALIDATION_ERROR",
          message: "Request payload failed schema validation.",
          details: { errors: compiledValidator!.errors, ref: "#4f628713c341" },
        },
        data: null,
      } as typeSquaresGridAddOutput400;
    }

    const prefix = options?.prefix ?? "";
    return (await call({
      payload,
      endpoint: `${prefix}/squares/grid-add`,
      httpMethod: "POST",
      options,
    })) as typeSquaresGridAddOutput200 | typeSquaresGridAddOutput400;
  };
}
